import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { resendChatSms } from "../../actions/resendChatSms.actions";
import { SmsMessage } from "../types/SmsMessage";
import { SMS_CONTACTS_QUERY_KEY } from "../../contacts/hooks/useSmsContactsQuery";
import { CHAT_SMS_QUERY_KEY } from "./useChatSmsQuery";
import { useGlobalSnackbar } from "../../../../../context/SnackbarContext";

export const useResendChatSmsMutation = () => {
  const queryClient = useQueryClient();
  const { showSnackbar } = useGlobalSnackbar();

  return useMutation<SmsMessage, Error, string>({
    mutationFn: resendChatSms,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [...SMS_CONTACTS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [...CHAT_SMS_QUERY_KEY] });
    },
    onError: (error: unknown) => {
      if (isAxiosError(error)) {
        const backendMessage =
          error.response?.data?.message || error.message || "Failed to resend message";

        showSnackbar(
          Array.isArray(backendMessage) ? backendMessage[0] : backendMessage,
          "error",
        );
        return;
      }

      showSnackbar(
        error instanceof Error ? error.message : "Failed to resend message",
        "error",
      );
    },
  });
};
